import { useFetch } from '../../hooks';
import { getCourse } from '../../api';

export const useCourse = (courseId: string) => {
  const { intializing: loading, data } = useFetch(
    () => (courseId ? getCourse(courseId) : null),
    [courseId],
    { skip: !courseId }
  );

  return {
    course: data,
    loading: loading,
  };
};
